import React from 'react'
import Checkbox from '@mui/material/Checkbox'
import styled from 'styled-components'

import { ActionCardProps, CheckboxProps } from 'types/TextAnalysis'

const CheckboxComponent = styled(Checkbox)<{ $show: boolean }>`
  display: ${({ $show }) => ($show ? 'grid' : 'none')};

  @media only screen and (max-width: 700px) {
    display: none !important;
  }
`

const CardCheckbox = React.memo(function CardCheckbox({
  id,
  showCheckbox,
  $checked,
  handleCheckboxClick,
}: ActionCardProps) {
  return (
    <CheckboxComponent
      size="small"
      id={`${id}-checkbox`}
      checked={$checked}
      $show={showCheckbox || false}
      {...CheckboxProps}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
        handleCheckboxClick?.(e.target.checked)
      }
    />
  )
})

export { CardCheckbox }
